import ReceivedIcon from './component'

export default ReceivedIcon
